import React from 'react';
import Hide from '@uber/base-icons/hide';
import Show from '@uber/base-icons/show';
import type { HeaderInfoT } from '../annotations/types';
import { ActionButton } from './action-button';
import { ICON_SIZE } from './constants';
type PropsT = {
  headerInfo: HeaderInfoT;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  size?: number;
};
export function ShowHideButton({
  headerInfo,
  onClick,
  size = ICON_SIZE
}: PropsT) {
  const {
    isVisible
  } = headerInfo;
  return <ActionButton icon={isVisible ? <Show size={size} /> : <Hide size={size} />} name={isVisible ? 'Hide all annotations' : 'Show all annotations'} onClick={onClick} />;
}